import { render, staticRenderFns } from "./ActivityItems.vue?vue&type=template&id=2bae4c7c&scoped=true&"
import script from "./ActivityItems.vue?vue&type=script&lang=js&"
export * from "./ActivityItems.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItems.vue?vue&type=style&index=0&id=2bae4c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae4c7c",
  null
  
)

export default component.exports